import type { Agenda } from "@repo/types";
import { AgendaModuleDisplay } from "../agendaModules/AgendaModuleDisplay";
import { MeetingDisplay } from "../meetings/MeetingDisplay";

export const AgendaSections = ({
  tenantId,
  meetingId,
  agenda,
}: {
  tenantId: string;
  meetingId?: string;
  agenda: Agenda;
}) => {
  return (
    <>
      <div className="p-2">
        <h1 className="text-2xl">Agenda Sections</h1>
        <div className="flex flex-col pt-4">
          {agenda.agendaModuleIds?.map((agendaModuleId) => (
            <AgendaModuleDisplay
              key={agendaModuleId}
              agendaModuleId={agendaModuleId}
              meetingId={meetingId}
              agendaId={agenda.id}
              tenantId={tenantId}
            />
          ))}
        </div>
      </div>
      <div className="p-2">
        <h1 className="text-2xl">Meeting Used In</h1>
        <div className="flex flex-col pt-4">
          {agenda.parentIds?.map((meetingId) => (
            <MeetingDisplay
              key={meetingId}
              meetingId={meetingId}
              tenantId={tenantId}
            />
          ))}
        </div>
      </div>
    </>
  );
};
